import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const checkIsAdmin = (currentUser) =>
  String(currentUser?.role || "").toLowerCase() === "admin" ||
  Boolean(currentUser?.is_admin || currentUser?.isAdmin);

/**
 * Composant de protection des routes
 * Vérifie l'authentification et redirige si nécessaire
 */
const ProtectedRoute = ({ children, user, token, requireAdmin = false }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      // Vérifier le localStorage en priorité (plus fiable)
      const storedToken = localStorage.getItem("token");
      const storedUser = localStorage.getItem("user");

      if (storedToken && storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser);
          console.log(
            "✅ Authentification valide depuis localStorage:",
            parsedUser
          );
          setIsAuthenticated(true);
          setIsAdmin(checkIsAdmin(parsedUser));
          setIsLoading(false);
          return;
        } catch (error) {
          console.error("❌ Erreur lors du parsing de l'utilisateur:", error);
          // Nettoyer les données corrompues
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }
      }

      // Vérifier si l'utilisateur est passé en props (fallback)
      if (user && token) {
        console.log("✅ Authentification valide depuis props:", user);
        setIsAuthenticated(true);
        setIsAdmin(checkIsAdmin(user));
        setIsLoading(false);
        return;
      }

      // Aucune authentification trouvée
      console.log("❌ Aucune authentification trouvée");
      setIsAuthenticated(false);
      setIsAdmin(false);
      setIsLoading(false);
    };

    checkAuth();
  }, [user, token]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Rediriger vers la page de connexion avec l'URL de retour
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
